import { AXOS_COIN } from './cryptoLookups';

export const formatCryptoAssetWithAxx = (crypto: string) => {
    return `${crypto.toUpperCase()}/${AXOS_COIN}`;
};
